import { OrganizationMember } from '@prisma/client'
import { message } from 'antd'
import { useEffect, useState } from 'react'
import { FindManyConversations, useSdk } from './useSdk'

type Props = {
  organizationMember: OrganizationMember
}

export const useConversations = ({ organizationMember }: Props) => {
  const [countRefresh, setCountRefresh] = useState<number>(0)
  const [conversations, setConversations] = useState<FindManyConversations>([])

  const sdk = useSdk({ organizationMember })

  const refresh = async () => {
    try {
      const conversationsFound = await sdk.findManyConversations({
        organizationMemberId: organizationMember.id,
      })

      setConversations(conversationsFound)
      setCountRefresh(value => value + 1)

      return conversationsFound
    } catch (error) {
      message.error(`Something went wrong`)
      console.error('Unknown Error', error)

      return conversations
    }
  }

  useEffect(() => {
    if (organizationMember) {
      refresh()
    }
  }, [organizationMember?.id])

  const findByOrganizationMember = (organizationMemberId: string) => {
    const conversation = conversations.find(candidate => {
      const participantFound = candidate.participants.find(
        participant =>
          participant.organizationMemberId === organizationMemberId,
      )
      const isDirectMessage = candidate.participants.length === 2
      return isDirectMessage && participantFound
    })

    return conversation
  }

  return { conversations, refresh, findByOrganizationMember, countRefresh }
}
